@if (viewModel) {
<div data-e2e="sub-item-suivi-conso" class="sub-item-picto">
  <div [ngClass]="{'border-bottom-0': hideBorder, 'pb-0': viewModel.noExtraBalance}">
    <div class="item-text">
      <span data-e2e="sub-item-label" class="label-picto">{{viewModel.label}}</span>
      <div class="picto-item">
        @if (viewModel.picto) {
        <span
          class="item-icon icon-Warning-important icon-size pt-10 pb-icon"
          aria-hidden="true"
          data-e2e="sub-item-picto"
        ></span>
        } @if (viewModel.consumption || viewModel.noExtraBalance) {
        <div class="progressbar m-0">
          <div class="progressbar-label" data-e2e="sub-item-consumption">{{viewModel.consumption}}</div>
          @if (viewModel.freeBies) {
          <small class="item-desc" data-e2e="sub-item-freeBies">{{viewModel.freeBies}}</small>
          } @if (viewModel.noExtraBalance) {
          <span data-e2e="sub-item-noExtraBalance">{{viewModel.noExtraBalance}}</span>
          }
        </div>
        }
      </div>
    </div>
  </div>
</div>
}
